import { render, staticRenderFns } from "./CardAgenda.vue?vue&type=template&id=9849d2e4&scoped=true"
import script from "./CardAgenda.vue?vue&type=script&lang=js"
export * from "./CardAgenda.vue?vue&type=script&lang=js"
import style0 from "./CardAgenda.vue?vue&type=style&index=0&id=9849d2e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9849d2e4",
  null
  
)

export default component.exports